import React, { lazy, Suspense } from 'react';
import type { ShareComposerSheetProps } from './ShareComposerSheet';

/**
 * Lazy wrapper for the share composer. Call sites (GoalCelebrationModal is
 * mounted app-wide) render this instead of the sheet directly so the share
 * stack — ShareCardArt, the viz components, and (via a second dynamic import
 * at export time) html-to-image — stays out of the entry chunk until a user
 * actually opens the composer (review M2).
 */
const Sheet = lazy(() => import('./ShareComposerSheet'));

export const ShareComposerSheetLazy: React.FC<ShareComposerSheetProps> = (props) => (
  <Suspense fallback={null}>
    <Sheet {...props} />
  </Suspense>
);
